import Icon from '../components/Icon.vue'

Icon.register({
  'thumbs-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M104 224H24C10.7 224 0 234.7 0 248V488C0 501.3 10.7 512 24 512H104C117.3 512 128 501.3 128 488V248C128 234.7 117.3 224 104 224zM64 472C50.7 472 40 461.3 40 448S50.7 424 64 424 88 434.7 88 448 77.3 472 64 472zM384 81.5C384 123.9 358 147.7 350.7 176H452.4C485.8 176 511.8 203.7 512 234.1 512.1 252 504.5 271.3 492.6 283.3L492.4 283.4C502.3 306.7 500.7 339.4 483.1 362.9 491.8 388.8 483.1 420.6 466.8 437.6 471.1 455.2 469 470.2 460.6 482.3 440.2 511.6 389.6 512 346.8 512L344 512C295.7 512 256.2 494.4 224.4 480.3 208.5 473.2 187.6 464.4 171.8 464.1 165.2 464 160 458.6 160 452.1V238.3C160 235.1 161.3 232.1 163.6 229.8 203.2 190.7 220.2 149.2 252.7 116.7 267.5 101.9 272.9 79.5 278.1 57.8 282.5 39.3 291.8 0 312 0 336 0 384 8 384 81.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/thumbs-up.js
// module id = ikjh
// module chunks = 144